export class FiltersOfConsult<T extends Object>{
  filters: T;
  private inititalFilters: T;

  constructor(_inititalFilters: T){
    this.inititalFilters = _inititalFilters;

    this.resetAll()
  }

  resetAll(){
    this.filters = {
      ...this.inititalFilters
    };
  }

  reset(params: Array<keyof T> ){
    params.map(key => this.filters[key] = this.inititalFilters[key])
  }

  setAll(_filters: T){
    this.filters = {
      ..._filters
    }
  }
}
